module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"subfooter__feature\">\r\n    <div class=\"row no-gutters\">\r\n      <div class=\"col-6\" ng-repeat=\"features in $ctrl.shCtrl.globalBanners.store_features.items\">\r\n        <div class=\"feature__block\" layout=\"column\" layout-align=\"center center\">\r\n          <img ng-src=\"{{features.imageUrl}}\" title=\"{{features.title}}\"\r\n               class=\"center-block\">\r\n        </div>\r\n      </div >\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/store-features/templates/store-features-adaptative.view.html
 ** module id = 119
 ** module chunks = 0
 **/